import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { Reso_mod } from "src/app/models/reso_mod.model";
import * as moment from 'moment'
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-reso_mod",
    templateUrl: "./reso_mod.component.html",
    styleUrls: ['./reso_mod.component.css'],
    providers: [FormService]
})

export class Reso_modComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public actualRow2;
    public reso_mod: Reso_mod;
    public form;
    public temp_reso_mod;
    public matcher = new FormService();
    public numeroForms = 0;
    public totalsup = 0;
    public maxDate;
    public fecha_reso;

    constructor(private dialog: MatDialog) {
        this.maxDate = moment().toDate()
        this.form = new FormGroup({

            reso_num: new FormControl(''),
            fecha_reso: new FormControl(''),
        })
        if (!JSON.parse(localStorage.getItem("reso_mod"))) {
            localStorage.setItem("reso_mod", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("reso_mod"));

            this.form.controls['reso_num'].setValue(this.rows[0] ? this.rows[0].reso_num : '')
            this.form.controls['fecha_reso'].setValue(this.rows[0] ? this.rows[0].fecha_reso : '')

        }
        this.reso_mod = { reso_num: '', fecha_reso: '' };
        this.temp_reso_mod = { reso_num: '', fecha_reso: '' };
    }

    add_reso_mod() {

        this.fecha_reso = moment().format('DD/MM/YYYY')
        this.actualRow = localStorage.getItem("reso_mod");

        this.rows = JSON.parse(this.actualRow);


        if (!this.form.value.reso_num) {
            console.log("no se ingresaron datos");
            this.dialog.open(this.openModalNODATA);
        } else {
            this.rows = this.rows.concat({
                reso_mod: this.form.value.reso_mod,
                reso_num: this.form.value.reso_num,
                fecha_reso: this.fecha_reso
            })
            localStorage.setItem("reso_mod", JSON.stringify(this.rows));
            this.form.reset();
        }
    }

    get_reso_mod(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_reso_mod.id = id;
                this.temp_reso_mod.reso_mod = this.rows[x].reso_mod;
                this.temp_reso_mod.reso_num = this.rows[x].reso_num;
                this.temp_reso_mod.fecha_reso = this.rows[x].fecha_reso;


                this.dialog.open(this.openModal);
            }
        }
    }

    cleanData() {
        this.temp_reso_mod = { reso_num: "", fecha_reso: "" };
    }

    save_reso_mod() {


        var id = this.temp_reso_mod.id;
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("reso_mod", JSON.stringify(this.rows));

                $("#clasif_modal").modal("hide");
                this.actualRow = localStorage.getItem("reso_mod");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({

                    reso_num: this.temp_reso_mod.reso_num,
                    fecha_reso: this.temp_reso_mod.fecha_reso

                })
                localStorage.setItem("reso_mod", JSON.stringify(this.rows));
                this.temp_reso_mod = { reso_num: "", fecha_reso: "" };
                this.dialog.closeAll();
            }
        }
    }

    delete_reso_mod(id) {
        
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("reso_mod", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('reso_mod'));
            }
        }
    }

}